import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { NOT_ACCOUNTING, notAccounting } from "@/lib/documents";

const HINT = {
  objednavka: "Objednávku založte v Objednávkách a PDF přiložte tlačítkem Přiložit soubor.",
  potvrzeni_objednavky: "Potvrzení přiložte k objednávce v Objednávkách tlačítkem Přiložit soubor.",
  nabidka: "Nabídku přiložte k zakázce nebo k objednávce.",
  dodaci_list: "Dodací list patří k převzetí objednávky. Náklad vznikne až fakturou.",
  upominka: "Upomínka připomíná fakturu, která už v Proyekty nejspíš je.",
  jine: "Do nákladů patří jen faktura, dobropis nebo účtenka.",
};

// 386: čtení dokladu poznalo objednávku, potvrzení objednávky, nabídku, dodací list nebo upomínku.
// Do nákladů ani do plateb to nepatří — uložit jako doklad jde jen po zaškrtnutí (server to hlídá taky).
export function NotInvoiceHint({ doc, setDoc, className = "" }) {
  if (!notAccounting(doc)) return null;
  const k = doc.doc_kind;
  return (
    <div role="alert" data-testid="not-invoice-hint" className={`rounded-[14px] border border-amber-500/40 bg-amber-500/10 p-3 md:p-4 text-sm space-y-2 ${className}`}>
      <p className="flex items-start gap-2 font-semibold text-amber-800 dark:text-amber-300">
        <AlertTriangle size={17} className="shrink-0 mt-0.5" aria-hidden />
        <span>Tohle vypadá jako {NOT_ACCOUNTING[k]}{doc.doc_title ? ` („${doc.doc_title}“)` : ""}, ne faktura. Do nákladů ani do plateb to nepatří.</span>
      </p>
      <p className="text-muted-foreground">
        {HINT[k]}{(k === "objednavka" || k === "potvrzeni_objednavky") && <> <Link to="/objednavky" className="text-brand font-semibold hover:underline" data-testid="not-invoice-orders">Otevřít Objednávky</Link></>}
      </p>
      <label className="flex items-center gap-2 font-semibold cursor-pointer">
        <Checkbox checked={!!doc.confirm_kind} onCheckedChange={(v) => setDoc((d) => ({ ...d, confirm_kind: !!v }))} data-testid="confirm-kind" />
        Je to opravdu faktura nebo účtenka, uložit jako doklad
      </label>
    </div>
  );
}
